// component
import ContractedProjectListCom from './contracted-project-list/contracted-project-list.vue';
import ConfirmDealBookCom from './confirm-deal-book/confirm-deal-book.vue';
import ConfirmContract from './confirm-contract/confirm-contract.vue';
import ContractPaymentCom from './contract-payment/contract-payment.vue';
import ContractFileList from './contract-file-list/contract-file-list.vue';
import UploadMaterial from './upload-material/upload-material.vue';

export default [
  {
    path: 'list',
    name: 'contractedProjectList',
    component: ContractedProjectListCom,
    meta: {
      title: '成交流转项目',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'confirm-deal-book',
    name: 'confirmDealBook',
    component: ConfirmDealBookCom,
    meta: {
      title: '确认成交书',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'confirm-contract',
    name: 'confirmContract',
    component: ConfirmContract,
    meta: {
      title: '确认合同',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'contract-payment',
    name: 'contractPayment',
    component: ContractPaymentCom,
    meta: {
      title: '支付合同款',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'contract-file-list',
    name: 'contractFilelist',
    component: ContractFileList,
    meta: {
      title: '项目文件',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'upload-material',
    name: 'Uploadmaterial',
    component: UploadMaterial,
    meta: {
      title: '上传材料',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  }
];

